import { MutableRefObject } from 'react';
import mapboxgl from 'mapbox-gl';

export const getMapBounds = (
  mapRef: MutableRefObject<mapboxgl.Map>,
  paddingFactor = 1,
) => {
  if (paddingFactor < 1) throw new Error('paddingFactor must be >= 1');
  if (paddingFactor > 2) throw new Error('paddingFactor must be <= 2');

  const bounds = mapRef.current.getBounds();
  if (!bounds) return [0, 0, 0, 0];
  let yMin = bounds.getSouth();
  let yMax = bounds.getNorth();
  let xMin = bounds.getWest();
  let xMax = bounds.getEast();

  // Add padding
  const xDiff = (xMax - xMin) * (paddingFactor - 1);
  const yDiff = (yMax - yMin) * (paddingFactor - 1);
  xMin -= xDiff;
  xMax += xDiff;
  yMin -= yDiff;
  yMax += yDiff;

  return [xMin, xMax, yMin, yMax];
};
